import { Box, Typography, CircularProgress } from "@mui/material";
import { useState } from "react";
import Dropzone from "react-dropzone";

import Notifications from "@/components/Notifications/Notifications";
import SiteIcons from "@/components/SiteIcons/SiteIcons";
import { isExcelFile } from "@/utils/util";

const dropZoneStyles = {
  border: "2px dashed #cccccc",
  height: "200px",
  borderRadius: "4px",
  cursor: "pointer",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  marginBottom: "1.5rem",
};

export default function Uploader({ handleFileSelection, loading }) {
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [notification, setNotification] = useState({});

  const onDrop = (fileToUpload) => {
    setSelectedFile(fileToUpload[0]);
    setSelectedFileName(fileToUpload[0].name);
    handleFileSelection(fileToUpload[0]);
  };

  return (
    <>
      <Box sx={[dropZoneStyles, { marginTop: "40px" }]} data-testid="dropzone">
        {!loading ? (
          <Dropzone onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
              <Box {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} data-testid="file-input" />
                <Box>
                  <Typography sx={{ fontSize: "1.3rem", marginBottom: "15px" }}>
                    {selectedFileName}
                  </Typography>
                  <SiteIcons iconstring="cloud-upload" page="uploader" />
                  <Typography>
                    Drag & drop a file here, or click to select a file
                  </Typography>
                </Box>
              </Box>
            )}
          </Dropzone>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {isExcelFile(selectedFile?.name) ? (
              <Typography sx={{ marginBottom: "20px", color: "darkslategray" }}>
                Please convert your file to CSV to improve processing times.
              </Typography>
            ) : null}
            <CircularProgress classes={{ svg: "purple" }} />
          </Box>
        )}
      </Box>

      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}
